import { combineReducers } from 'redux'

import resultados from './detalhesObrasParadas'
import eventos from './eventosObras'
import empreiteiras from './empreiteirasObras'
import responsaveis from './responsaveis'
import medicoes from './medicoesObras'

export default combineReducers({ resultados, eventos, empreiteiras, responsaveis, medicoes })
